import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=3d822b8c&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=3d822b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d822b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d822b8c')) {
      api.createRecord('3d822b8c', component.options)
    } else {
      api.reload('3d822b8c', component.options)
    }
    module.hot.accept("./imgUpload.vue?vue&type=template&id=3d822b8c&scoped=true&", function () {
      api.rerender('3d822b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homePageCopyWriter/components/imgUpload.vue"
export default component.exports